import React from 'react';
import PropTypes from 'prop-types';

import '../style/map-style.css';
// preserveAspectRatio="xMidYMid meet"
const USMap = ({ CheckSelection, states }) => (
  <div className="map__container">
    <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="-200 0 1250 600" preserveAspectRatio="none">
      {
        states.map(v =>
          (<path
            id={v.id}
            key={v.id}
            d={v.d}
            className={v.className && v.className}
            onClick={CheckSelection}
          />)
        )
      }
    </svg>
  </div>
);

USMap.propTypes = {
  CheckSelection: PropTypes.func.isRequired,
  states: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default USMap;



// WEBPACK FOOTER //
// ./src/components/USMap.js